<section class="coins-display__container">
           

    <owl-carousel-o [options]="customOptions">

        <ng-container *ngFor="let coin of coins">
          <ng-template carouselSlide [id]="coin.id">
      
       
            <div class="card-content" (click)="navigate(coin)">
                <div class="coin-display__card">
                  <div class="card-top">
                    <div class="display-card__title">
                      <h4 class="coin-detail__title">Coin Details ({{ coin?.custom_id || 'N/A' }})</h4>
                    </div>
                    
                  </div>
              
                  <div >
                    <div class="coin-details__meta" *ngIf="coin">
             
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Year</li>
                                    <li class="coin-details__meta-des">{{coin?.year ? coin?.year:'N/a'}}</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Mint</li>
                                    <li class="coin-details__meta-des">{{coin.mint ? coin.mint:'N/a'}}</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Type</li>
                                    <li class="coin-details__meta-des">{{coin.type ? coin.type:'N/a'}}</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Denomination</li>
                                    <li class="coin-details__meta-des">{{coin.denomination ? coin.denomination:'N/a'}}</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Variety</li>
                                    <li class="coin-details__meta-des">{{coin.variety ? coin.variety:'N/a'}}</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Proof</li>
                                    <li class="coin-details__meta-des">{{coin.proof ? coin.proof:'N/a'}}</li>
                                </ul>
                            </div>
                        </div>
            
                      </div>
                    </div>
              
                    <div class="img-box">
                      <div class="left-coin__img">
          
                        <img [src]="getTransformedImageUrl(coin?.front_image_url)  || 'assets/images/gallery/picupload.png'" class="img-fluid coin-img" alt="coin-imgone">
            
                    </div>
                    <div class="right-coin__img">
             
                        <img [src]="getTransformedImageUrl(coin?.back_image_url) || 'assets/images/gallery/picupload.png'" class="img-fluid coin-img" alt="coin-imgone">
           
                    </div>
                    </div>
              
         
            
              
                    <div class="display-card__button" >
                      <button class="primary-btn btn">Coin Detail</button>
                    </div>
              
             
                  </div>
              
      
                </div>
         
      
          </ng-template>
        </ng-container>
    
      </owl-carousel-o>
    <!-- <div class="row gx-8">


        <div class="col-md-6 col-lg-4 col-12">
       
            <div class="card-content">
                <div class="coin-display__card">
                    <div class="card-top">
                    <div class="display-card__title">
                      
                     <h4 class="coin-detail__title">Coin Details</h4>
                    </div>
                </div>
                    <div class="coin-details__meta">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Year</li>
                                    <li class="coin-details__meta-des">Year</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Mint</li>
                                    <li class="coin-details__meta-des">Mint</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Type</li>
                                    <li class="coin-details__meta-des">Type</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Denomination</li>
                                    <li class="coin-details__meta-des">Denomination</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Variety</li>
                                    <li class="coin-details__meta-des">Variety</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Finish</li>
                                    <li class="coin-details__meta-des">Proof</li>
                                </ul>
                            </div>
                        </div>



                    </div>

                </div>
                <div class="img-box">
                    <div class="left-coin__img">
                        <img src="assets/images/gallery/coin-imgone.png" class="img-fluid" alt="coin-imgone">
                    </div>
                    <div class="right-coin__img">
                        <img src="assets/images/gallery/coin-imgtwo.png" class="img-fluid" alt="coin-imgone">
                    </div>
                </div>
                <div class="display-card__button">
                    <button class="primary-btn btn">
                        Assess Coin Now
                    </button>
                </div>



            </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12">
            <div class="card-content">
                <div class="coin-display__card">
                    <div class="card-top">
                        <div class="display-card__title">
                            <h4 class="coin-detail__title">Coin Details</h4>
                           </div>
                    </div>
                    
                    <div class="coin-details__meta">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Year</li>
                                    <li class="coin-details__meta-des">1934</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Denominationination</li>
                                    <li class="coin-details__meta-des">?</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Mint</li>
                                    <li class="coin-details__meta-des">?</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Variety</li>
                                    <li class="coin-details__meta-des">?</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Year</li>
                                    <li class="coin-details__meta-des">Peace Dollar</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Finish</li>
                                    <li class="coin-details__meta-des">?</li>
                                </ul>
                            </div>
                        </div>



                    </div>

                </div>
                <div class="img-box">
                    <div class="left-coin__img">
                        <img src="assets/images/gallery/coin-imgone.png" class="img-fluid" alt="coin-imgone">
                    </div>
                    <div class="right-coin__img">
                        <img src="assets/images/gallery/coin-imgtwo.png" class="img-fluid" alt="coin-imgone">
                    </div>
                </div>
                <div class="display-card__button">
                    <button class="primary-btn btn">
                        Assess Coin Now
                    </button>
                </div>



            </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12">
            <div class="card-content">
                <div class="coin-display__card">
                    <div class="card-top">
                    <div class="display-card__title">
                      
                     <h4 class="coin-detail__title">Coin Details</h4>
                    </div>
                </div>
                    <div class="coin-details__meta">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Year</li>
                                    <li class="coin-details__meta-des">1934</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Denomination</li>
                                    <li class="coin-details__meta-des">Dollar</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Mint</li>
                                    <li class="coin-details__meta-des">Philadelphia</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Variety</li>
                                    <li class="coin-details__meta-des">n/a</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">type</li>
                                    <li class="coin-details__meta-des">Peace Dollar</li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-6">
                                <ul class="coin-details__meta-group">
                                    <li class="coin-details__meta-label">Finish</li>
                                    <li class="coin-details__meta-des">Not Proof</li>
                                </ul>
                            </div>
                          
                        </div>



                    </div>

                </div>
                <div class="img-box">
                    <div class="left-coin__img">
                        <img src="assets/images/gallery/coin-imgone.png" class="img-fluid" alt="coin-imgone">
                    </div>
                    <div class="right-coin__img">
                        <img src="assets/images/gallery/coin-imgtwo.png" class="img-fluid" alt="coin-imgone">
                    </div>
                </div>
                <div class="display-card__details">
                    <div class="col-12">
                       
                            <h3>Assessment Details</h3>
                    
                    </div>
                    <div class="assesment-details">
                        <div class="assesment-details__text">
                            <span class="elipse-one"></span>
                           <div>
                            <p class="elipse-title">Mean</p>
                            <p class="elipse-value">40</p>
                           </div>
                        </div>
                        <div class="assesment-details__text">
                            <span class="elipse-two"></span>
                           <div>
                            <p class="elipse-title">Mean</p>
                            <p class="elipse-value">40</p>
                           </div>
                        </div>
                        <div class="assesment-details__text">
                            <span class="elipse-three"></span>
                           <div>
                            <p class="elipse-title">Mean</p>
                            <p class="elipse-value">40</p>
                           </div>
                        </div>

                    </div>
                    <div class="total-assesment">
                        <span class="total-value_assesment">333</span>
                        <span class="total-value_title">Total Assessments</span>
                    </div>
                </div>



            </div>
        </div>
    </div> -->




</section>